import React, { useMemo } from 'react'
import { ADD_SUGGESTION_TEXT } from '@chegg-wt/core-wa/constants/paraphraser'
import { GrammarSuggestionCardText, ReplacementText } from './styled'
import { splitSuggestedtext } from './utils'

export const enum ADD_TYPES {
  BETWEEN,
  BEFORE,
  AFTER,
}

const getAddTextDescription = (addtype: ADD_TYPES, prefix: string, suffix: string) => {
  switch (addtype) {
    case ADD_TYPES.BETWEEN: {
      return (
        <>
          <span> between </span>
          <span>
            <q>{prefix}</q>
          </span>
          <span> and </span>
          <span>
            <q>{suffix}</q>
          </span>
        </>
      )
    }
    case ADD_TYPES.AFTER: {
      return (
        <>
          <span> after </span>
          <span>
            <q>{prefix}</q>
          </span>
        </>
      )
    }
    case ADD_TYPES.BEFORE: {
      return (
        <>
          <span> before </span>
          <span>
            <q>{suffix}</q>
          </span>
        </>
      )
    }
    default:
      return null
  }
}

export const AddSuggestionText = ({ impactedText, suggestedText }) => {
  const { suffix, prefix, highlightedText, addType } = useMemo(
    () => splitSuggestedtext(impactedText, suggestedText),
    [impactedText, suggestedText]
  )

  return (
    <GrammarSuggestionCardText data-test={ADD_SUGGESTION_TEXT}>
      <span>Add </span>
      <ReplacementText>
        <q>{highlightedText}</q>
      </ReplacementText>
      {getAddTextDescription(addType, prefix, suffix)}
    </GrammarSuggestionCardText>
  )
}
